import { i18n } from '@/lib/i18n'

/** Tên hiển thị của các nguồn dữ liệu (hồ sơ, đơn hàng, sự kiện) — khớp khoá backend. Tên riêng (Zalo, Facebook…) giữ nguyên. */
const SOURCE_LABEL_KEYS: Record<string, string> = {
  manual: 'manual',
  import: 'import',
  web: 'web',
  chat: 'chat',
  bot: 'bot',
  ai: 'ai',
  api: 'api',
  system: 'system',
  legacy: 'legacy',
}
const SOURCE_PROPER_NAMES: Record<string, string> = {
  evotech: 'Evotech',
  zalo_oa: 'Zalo OA',
  zalo: 'Zalo',
  facebook: 'Facebook',
  pancake: 'Pancake',
  tiktok: 'TikTok Shop',
  tiktok_shop: 'TikTok Shop',
  shopee: 'Shopee',
  telegram: 'Telegram',
}
export const sourceLabel = (k: string): string => {
  const key = SOURCE_LABEL_KEYS[k]
  return key ? i18n.t(`sharedMisc:dataSources.${key}`) : SOURCE_PROPER_NAMES[k] ?? k
}
